// JavaScript Document
$(document).ready(function(e) {
  $('.wholesale-volume-image').click(function(e) {
    if ($(this).hasClass('zoomed')) {
				$(this).removeClass('zoomed');
				$('.section-discover-alra').css('padding-bottom',0);
		}
		else {
			$(this).addClass('zoomed');
			$('.section-discover-alra').css('padding-bottom',$(this).height()+'px');
		}
  });
});